(function () {
  /** @type {(() => void) | null} */
  let stickyTeardown = null;

  /**
   * @param {HTMLElement} header
   */
  function initStickyHeader(header) {
    if (stickyTeardown) stickyTeardown();
    const headerSection =
      header.closest('.shopify-section') ||
      header.closest('.shopify-section-group') ||
      header.parentElement;
    if (!headerSection) {
      console.debug('[vibee-header] sticky skip: no section wrapper');
      return;
    }

    let wasStuck = false;

    function applyStuckHeight() {
      document.documentElement.style.setProperty(
        '--vibee-header-stuck-height',
        `${header.offsetHeight}px`,
      );
    }

    function clearStuckState() {
      header.classList.remove('is-stuck');
      headerSection.classList.remove('is-header-stuck');
      headerSection.style.removeProperty('--vibee-header-flow-height');
      headerSection.style.removeProperty('min-height');
      document.documentElement.style.removeProperty('--vibee-header-stuck-height');
      wasStuck = false;
    }

    /**
     * @param {boolean} shouldStick
     */
    function setStuck(shouldStick) {
      if (shouldStick) {
        if (!wasStuck) {
          const flowHeight = header.offsetHeight;
          headerSection.style.setProperty(
            '--vibee-header-flow-height',
            `${flowHeight}px`,
          );
          headerSection.style.minHeight = `${flowHeight}px`;
          header.classList.add('is-stuck');
          headerSection.classList.add('is-header-stuck');
          wasStuck = true;
        }
        applyStuckHeight();
        return;
      }

      if (wasStuck) clearStuckState();
    }

    function getStuckThreshold() {
      const docTop =
        headerSection.getBoundingClientRect().top + window.scrollY;
      return docTop + 4;
    }

    function onResize() {
      if (!wasStuck) return;

      const flowHeight = headerSection.style.getPropertyValue(
        '--vibee-header-flow-height',
      );
      if (flowHeight) {
        headerSection.style.minHeight = flowHeight;
      }
      applyStuckHeight();
    }

    let ticking = false;
    let lastY = window.scrollY;
    /** @type {ReturnType<typeof setInterval> | null} */
    let scrollPollId = null;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setStuck(window.scrollY > getStuckThreshold());
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, {passive: true});
    document.addEventListener('scroll', onScroll, {passive: true, capture: true});
    scrollPollId = setInterval(() => {
      if (lastY !== window.scrollY) {
        lastY = window.scrollY;
        onScroll();
      }
    }, 250);
    window.addEventListener('resize', onResize, {passive: true});
    onScroll();
    console.debug('[vibee-header] sticky init (scroll)', {
      threshold: getStuckThreshold(),
      headerSection,
    });

    stickyTeardown = () => {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('scroll', onScroll, true);
      if (scrollPollId !== null) {
        clearInterval(scrollPollId);
        scrollPollId = null;
      }
      window.removeEventListener('resize', onResize);
      stickyTeardown = null;
    };
  }

  /**
   * @param {HTMLElement} header
   */
  function initMobileMenu(header) {
    const overlay = header.querySelector('[data-vibee-menu-overlay]');
    const drawer = header.querySelector('[data-vibee-menu-drawer]');
    const openBtn = header.querySelector('[data-vibee-menu-open]');
    const closeBtns = header.querySelectorAll('[data-vibee-menu-close]');
    const crown = header.querySelector('.vibee-header__drawer-vibees-crown');

    /**
     * @param {boolean} open
     */
    function setOpen(open) {
      const isOpen = Boolean(open);
      overlay?.classList.toggle('is-open', isOpen);
      drawer?.classList.toggle('is-open', isOpen);
      openBtn?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      overlay?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      drawer?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.documentElement.classList.toggle('vibee-menu-open', isOpen);

      if (isOpen && crown) {
        crown.classList.remove('is-pop');
        void crown.offsetWidth;
        crown.classList.add('is-pop');
      } else if (crown) {
        crown.classList.remove('is-pop');
      }
    }

    openBtn?.addEventListener('click', () => setOpen(true));
    closeBtns.forEach((btn) => btn.addEventListener('click', () => setOpen(false)));
    overlay?.addEventListener('click', () => setOpen(false));
  }

  /**
   * @param {HTMLElement} header
   */
  function initDrawerVibeesBanner(header) {
    const banner = header.querySelector('[data-vibee-drawer-vibees]');
    if (!banner) return;

    banner.addEventListener('click', (event) => {
      const smile = window.SmileUI;
      if (smile && typeof smile.openPanel === 'function') {
        event.preventDefault();
        smile.openPanel();
      }
    });
  }

  function boot() {
    console.debug('[vibee-header] init');
    const header = document.querySelector('.vibee-header');
    if (!header) {
      console.debug('[vibee-header] skip: .vibee-header not found');
      return;
    }
    initStickyHeader(header);
    initMobileMenu(header);
    initDrawerVibeesBanner(header);
  }

  function scheduleBoot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, {once: true});
    } else {
      boot();
    }
  }

  scheduleBoot();
  document.addEventListener('shopify:section:load', boot);
})();
